/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PendingEvaluationSubmittedAt } from './pendingEvaluationSubmittedAt';
import type { PendingEvaluationGradedAt } from './pendingEvaluationGradedAt';
import type { PendingEvaluationDueDate } from './pendingEvaluationDueDate';
import type { PendingEvaluationGrade } from './pendingEvaluationGrade';
import type { ModuleSubmissionState } from './moduleSubmissionState';
import type { _PendingEvaluationLinks } from './_pendingEvaluationLinks';

/**
 * A pending evaluation for a lecturer, set of submissions for module for a lecturer to grade
Evaluation is the feedback on a whole submitted module (feedback, grade, ...)
 */
export interface PendingEvaluation {
  userId: string;
  module: string;
  student: string;
  courseId: string;
  moduleId: string;
  studentId: string;
  submittedAt: PendingEvaluationSubmittedAt;
  gradedAt: PendingEvaluationGradedAt;
  dueDate: PendingEvaluationDueDate;
  grade: PendingEvaluationGrade;
  state: ModuleSubmissionState;
  _links: _PendingEvaluationLinks;
}
